export default __webpack_public_path__ + "static/person_2-97c21a5b4b08e4bb021a7ab30bc59181.webp";